import IconButton, {
    IconButtonVariant,
} from '@/components/Redactie/IconButton/IconButton';
import {
    mdiDeleteForever,
    mdiProgressCheck,
    mdiProgressClose,
    mdiShapeCirclePlus,
} from '@mdi/js';

interface EditButtonBarProps {
    saveButton: EditButtonBarButonProps;
    cancelButton?: EditButtonBarButonProps;
    deleteButton?: EditButtonBarButonProps;
    addButton?: EditButtonBarButonProps;
    className?: string;
}

interface EditButtonBarButonProps {
    show?: boolean;
    buttonText?: string;
    labelText?: string;
    enabled?: boolean;
    onClick: null | (() => void);
}

const EditButtonBar = ({
    saveButton = { show: true, enabled: true, onClick: null },
    cancelButton = { show: true, enabled: true, onClick: null },
    deleteButton = { show: false, enabled: true, onClick: null },
    addButton = { show: false, enabled: true, onClick: null },
    className = '',
}: EditButtonBarProps) => {
    const numberOfButtons =
        (saveButton.show ? 1 : 0) +
        (cancelButton.show ? 1 : 0) +
        (deleteButton.show ? 1 : 0) +
        (addButton.show ? 1 : 0);

    return (
        <div
            className={`grid ${
                numberOfButtons == 2
                    ? 'grid-cols-2'
                    : numberOfButtons == 3
                    ? 'grid-cols-3'
                    : 'grid-cols-4'
            } gap-4 ${className}`}
        >
            {deleteButton.show && deleteButton.onClick && (
                <IconButton
                    icon={mdiDeleteForever}
                    onClick={deleteButton.onClick}
                    label={deleteButton.labelText || 'Permanent verwijderen'}
                    enabled={deleteButton.enabled}
                >
                    {deleteButton.buttonText || 'Verwijderen'}
                </IconButton>
            )}
            {cancelButton.show && cancelButton.onClick && (
                <IconButton
                    icon={mdiProgressClose}
                    onClick={cancelButton.onClick}
                    label={cancelButton.labelText || 'Wijzigingen annuleren'}
                    enabled={cancelButton.enabled}
                >
                    {cancelButton.buttonText || 'Annuleren'}
                </IconButton>
            )}
            {addButton.show && addButton.onClick && (
                <IconButton
                    icon={mdiShapeCirclePlus}
                    onClick={addButton.onClick}
                    label={addButton.labelText || 'Item toevoegen'}
                    variant={IconButtonVariant.Primary}
                    enabled={addButton.enabled}
                >
                    {addButton.buttonText || 'Toevoegen'}
                </IconButton>
            )}
            {saveButton.show && saveButton.onClick && (
                <IconButton
                    icon={mdiProgressCheck}
                    onClick={saveButton.onClick}
                    label={saveButton.labelText || 'Wijzigingen opslaan'}
                    variant={IconButtonVariant.Success}
                    enabled={saveButton.enabled}
                >
                    {saveButton.buttonText || 'Opslaan'}
                </IconButton>
            )}
        </div>
    );
};

export default EditButtonBar;
